import styles from './styles.module.css'
import React from 'react'

interface IReferenceMediaSectionProps {
  children: React.ReactNode
  enabled?: boolean
}

/** Shared reference-media card for photo/video instructions and Info box attachments. */
export function ReferenceMediaSection({ children, enabled = true }: IReferenceMediaSectionProps) {
  return <div className={enabled ? styles.section : undefined}>{children}</div>
}
